import { Box, Heading, Link } from "@chakra-ui/react";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import { useAccount } from "wagmi";

import Holdings from "../components/wallet/Holdings";
import Streams from "../components/wallet/Streams";
import Subscriptions from "../components/wallet/Subscriptions";

function Wallet() {
  const { address } = useAccount();

  return (
    <Box
      display={{ base: "block", md: "flex" }}
      flexDir={{ md: "column" }}
      marginX="auto"
      maxW={{ base: "100%", md: "fit-content" }}
      px={{ base: "1em", md: "0" }}
      py="2.5em"
    >
      <Heading size="lg" mb="1em">
        Your Wallet
      </Heading>

      <ConnectButton label="Connect!" />

      {address && (
        <>
          <Streams account={address} />
          <Holdings account={address} />
          <Subscriptions account={address} />
        </>
      )}

      <Link mt="10em" display="block" href="https://app.superfluid.finance" isExternal>
        🖥️ Go to your Superfluid Dashboard.
      </Link>
    </Box>
  );
}

export default Wallet;
